import React from "react";
import {
  ArrowRight,
  MessageCircle,
  Code2,
  Users,
  Award,
  Sparkles,
} from "lucide-react";
import { Link } from "react-router-dom";

function InternshipCTA() {
  const points = [
    { icon: Code2, text: "Live Projects" },
    { icon: Users, text: "Expert Mentors" },
    { icon: Award, text: "Certificate" },
  ];

  return (
    <section className="bg-white dark:bg-[#050505] px-6 lg:px-16 py-12">
      <div className="relative max-w-7xl mx-auto overflow-hidden rounded-3xl border border-primary/20 bg-gradient-to-br from-[#070b0d] via-[#0b1014] to-[#111827] px-6 md:px-10 py-8 shadow-[0_0_55px_rgba(254,120,83,0.18)]">
        <div className="absolute -left-10 -bottom-10 w-52 h-52 bg-primary/25 blur-[90px] rounded-full"></div>
        <div className="absolute -right-10 -top-10 w-64 h-64 bg-orange-500/20 blur-[100px] rounded-full"></div>

        <div className="relative z-10 grid lg:grid-cols-[16%,60%,20%] gap-8 items-center">
          <div className="hidden lg:flex justify-center">
            <div className="relative">
              <div className="absolute inset-0 bg-primary/30 blur-xl rounded-full animate-pulse"></div>
              <div className="relative h-32 w-32 rounded-full bg-white/5 p-1.5 border border-primary/30 overflow-hidden shadow-[0_0_35px_rgba(254,120,83,0.35)]">
                <img
                  src="myai.png"
                  alt="AI Assistant"
                  className="w-full h-full object-cover rounded-full"
                />
              </div>
            </div>
          </div>

          <div>
            <div className="inline-flex items-center gap-2 rounded-full border border-primary/30 bg-primary/10 px-4 py-1.5 mb-3">
              <Sparkles className="w-4 h-4 text-primary" />
              <span className="text-xs font-semibold text-primary uppercase tracking-wide">
                Polytechnic Internship
              </span>
            </div>

            <h2 className="text-2xl md:text-4xl font-bold text-white leading-tight">
              Start Your Internship {""}
              <span className="text-primary">Journey Today</span>
            </h2>

            <p className="mt-3 text-sm md:text-base text-gray-300 max-w-2xl leading-relaxed">
              Gain practical skills, work on live projects, and earn an
              industry-recognized certificate with Web X Secure.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row lg:flex-col gap-4 lg:items-end">
            <Link
              to="/contact"
              className="group inline-flex items-center justify-center gap-2 rounded-xl bg-primary px-7 py-3 text-sm font-semibold text-white shadow-[0_0_35px_rgba(254,120,83,0.35)] hover:scale-105 transition-all duration-300"
            >
              Apply Now
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition" />
            </Link>

            <a
              href="https://wa.me/919785549138"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 rounded-xl border border-primary/40 bg-white/5 px-7 py-3 text-sm font-semibold text-white hover:bg-primary hover:border-primary transition-all duration-300"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default InternshipCTA;
